'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LoginButton = exports.ENGAGEMENT_ELEMENTS = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _props = require('../props');

var _LoggedInBadge = require('../LoggedInBadge');

var _LoggedInBadge2 = _interopRequireDefault(_LoggedInBadge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-named-as-default */

var LOGIN_BUTTON = 'login';

var DEFAULT_MY_SUBSCRIPTION_LABEL = 'MY SUBSCRIPTION';
var DEFAULT_MY_ACCOUNT_LABEL = 'MY ACCOUNT';
var DEFAULT_LOGIN_LABEL = 'LOGIN';

var ENGAGEMENT_ELEMENTS = exports.ENGAGEMENT_ELEMENTS = {
    LOGIN: 'Masthead_Login'
};

var renderLoggedInState = function renderLoggedInState(params) {
    var LoggedInWidget = params.widgets && params.widgets.LoggedInWidget;
    return LoggedInWidget ? _react2.default.createElement(LoggedInWidget, params) : _react2.default.createElement(_LoggedInBadge2.default, (0, _extends3.default)({}, params, { placement: _LoggedInBadge2.default.IN_MASTHEAD_EXTENSION }));
};

var renderLoggedOutState = function renderLoggedOutState(params, engagement) {
    var login = params.login,
        spid = params.spid,
        btnClasses = params.btnClasses,
        widgets = params.widgets;


    var LoginWidget = widgets && widgets.LoginWidget;
    var defaultLogin = _react2.default.createElement(
        'button',
        {
            className: btnClasses,
            onClick: function onClick(event) {
                _promise2.default.race([engagement({
                    elementIdentifier: ENGAGEMENT_ELEMENTS.LOGIN,
                    meta: { name: login, event: event }
                }), new _promise2.default(function (resolve) {
                    return setTimeout(resolve, 1000);
                })]).catch(function () {
                    return undefined;
                }).then(function () {
                    return spid.login();
                });
            }
        },
        login
    );

    return LoginWidget ? _react2.default.createElement(LoginWidget, params) : defaultLogin;
};

var LoginButton = exports.LoginButton = function LoginButton(props) {
    var _classNames;

    var theme = props.theme,
        spid = props.spid,
        widgets = props.widgets,
        engagement = props.engagement,
        attributes = props.attributes,
        mastheadExtension = props.mastheadExtension,
        focusable = props.focusable;
    var labels = mastheadExtension.labels,
        userLoggedInSvg = mastheadExtension.svg.userLoggedIn,
        mastheadExtensionButton = mastheadExtension.button,
        myPage = mastheadExtension.myPage;


    if (!spid.login && !spid.loggedIn) {
        // if login URL not yet available, do not render login control
        return null;
    }

    var btnClasses = (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, theme.root, true), (0, _defineProperty3.default)(_classNames, theme.userLoggedIn, spid.loggedIn), (0, _defineProperty3.default)(_classNames, theme.enabledOnMobile, mastheadExtensionButton === LOGIN_BUTTON), (0, _defineProperty3.default)(_classNames, theme.hidden, !focusable), _classNames));

    var _labels$mySubscriptio = labels.mySubscription,
        mySubscription = _labels$mySubscriptio === undefined ? DEFAULT_MY_SUBSCRIPTION_LABEL : _labels$mySubscriptio,
        _labels$myAccount = labels.myAccount,
        myAccount = _labels$myAccount === undefined ? DEFAULT_MY_ACCOUNT_LABEL : _labels$myAccount,
        _labels$login = labels.login,
        login = _labels$login === undefined ? DEFAULT_LOGIN_LABEL : _labels$login;


    var commonProps = { theme: theme, spid: spid, btnClasses: btnClasses, engagement: engagement, attributes: attributes, widgets: widgets };

    return spid.loggedIn ? renderLoggedInState((0, _extends3.default)({}, commonProps, {
        userLoggedInSvg: userLoggedInSvg,
        mastheadExtensionButton: mastheadExtensionButton,
        myPage: myPage,
        labels: {
            mySubscription: mySubscription,
            myAccount: myAccount
        },
        focusable: focusable
    })) : renderLoggedOutState((0, _extends3.default)({}, commonProps, {
        login: login
    }), engagement);
};

if (process.env.NODE_ENV !== 'production') {
    LoginButton.propTypes = {
        engagement: _propTypes2.default.func,
        attributes: _propTypes2.default.func,
        spid: _propTypes2.default.shape({
            login: _propTypes2.default.func,
            loggedIn: _propTypes2.default.bool.isRequired,
            givenName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(null)]),
            familyName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(null)])
        }).isRequired,
        mastheadExtension: _propTypes2.default.shape(_props.mastheadExtensionProps).isRequired,
        theme: _propTypes2.default.shape({
            root: _propTypes2.default.string,
            userLoggedIn: _propTypes2.default.string,
            enabledOnMobile: _propTypes2.default.string,
            subscriptionLabel: _propTypes2.default.string,
            userName: _propTypes2.default.string,
            userDescription: _propTypes2.default.string
        }),
        focusable: _propTypes2.default.bool
    };
}

LoginButton.defaultProps = {
    theme: {},
    attributes: function attributes() {},
    engagement: function engagement() {
        return _promise2.default.resolve();
    },
    focusable: true
};

exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        spid: state.spid
    };
})(LoginButton);
//# sourceMappingURL=LoginButton.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/components/LoginButton/LoginButton.js
 ** module id = 599
 ** module chunks = 1
 **/